import { render, staticRenderFns } from "./NoticeDialogComponent.vue?vue&type=template&id=154dc11b&scoped=true"
import script from "./NoticeDialogComponent.vue?vue&type=script&lang=js"
export * from "./NoticeDialogComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "154dc11b",
  null
  
)

export default component.exports